import { createAction, props } from '@ngrx/store';
import { Edge } from '../../../edge/edge.model';
import { GetUnSyncedEdgesDto } from '../../../services/sync-queue.service';

export const resetToInitialState = createAction('[UNSYNCED-EDGES] Reset to Initial state');

export const getUnSyncedEdges = createAction(
  '[UNSYNCED-EDGES] Get Unsynced Edges',
  props<{ filters: GetUnSyncedEdgesDto }>()
);

export const getUnSyncedEdgesSuccess = createAction(
  '[UNSYNCED-EDGES] Get Unsynced Edges Success',
  props<{ items: Edge.EdgeSyncQueueDocument[], total: number, page: number }>()
);

export const loadMoreUnSyncedEdges = createAction('[UNSYNCED-EDGES] Load more Unsynced Edges');

export const getUnSyncedEdgesFail = createAction(
  '[UNSYNCED-EDGES] Get Unsynced Edges Fail',
  props<{ error: any }>()
);

export const setInitialLoader = createAction(
  '[UNSYNCED-EDGES] Set Initial Loader',
  props<{ loading: boolean }>()
);

export const setFilters = createAction(
  '[UNSYNCED-EDGES] Set Filters',
  props<{ filters: GetUnSyncedEdgesDto }>()
); 